var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSuccessful(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 575 575",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3cbb97;}.cls-1,.cls-2,.cls-3{stroke-width:0px;}.cls-2{fill:none;}.cls-3{fill:#fff;}.cls-4{clip-path:url(#clippath);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 575,
    height: 575
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32425",
    className: "cls-1",
    d: "M0,287.5C0,128.72,128.72,0,287.5,0s287.5,128.72,287.5,287.5-128.72,287.5-287.5,287.5C128.79,574.82.18,446.21,0,287.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32426",
    className: "cls-3",
    d: "M474.69,157.98c-6.74-12-19.37-19.49-33.13-19.64-.96,0-1.83,0-2.73.11h-.29c-1.15.01-2.3.12-3.43.32-9.51,1.74-17.98,7.08-23.66,14.9l-157.43,184.8-63.76-69.25c-7.25-7.67-17.4-11.92-27.95-11.7-9.22-.18-18.16,3.12-25.06,9.24-14.41,14.45-15.22,37.57-1.86,53l94.3,102.25c7.11,7.38,16.99,11.44,27.24,11.2,11.79.33,23.04-4.93,30.35-14.17l183.86-220.32c8.94-11.76,10.32-27.61,3.57-40.74"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccessful);
export default __webpack_public_path__ + "static/media/icon-successful.a25bc87b1dece8fe004d40b6f7c82115.svg";
export { ForwardRef as ReactComponent };